import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ViewChildren,
  QueryList,
  ViewChild,
  ElementRef,
  inject,
  OnDestroy
} from '@angular/core';
import {
  UntypedFormGroup,
  Validators,
  UntypedFormBuilder,
  UntypedFormControl,
  FormGroup,
  FormControl
} from '@angular/forms';

import * as _ from 'underscore';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ActivatedRoute } from '@angular/router';

import { distinctUntilChanged, first, last, map, take, takeUntil } from 'rxjs/operators';

import moment from 'moment';
import { BaseComponent } from '../../../../components/base/base.component';
import {
  compare,
  SortEvent,
  TableSorterDirective
} from '../../../../directives/table-sorter.directive';
import { PeopleService } from '../../../../services/people.service';
import { SharedService } from '../../../../services/shared.service';
import { CompaniesService } from '../../../../services/companies.service';
import {
  CompanyLocationConfig,
  PayrollCalendarSetup
} from '../../../../models/company-location-config';
import {
  EmployeeLaborAllocation,
  EmployeeLaborAllocationHistory,
  JobCode,
  LaborAllocationTypes
} from '../../../../models/labor-allocation';
import { AuthService } from '../../../../services/auth.service';
import { ModalService } from '../../../../services/modal.service';
import { Division } from '../../../../models/division';
import { Client } from '../../../../models/client';
import { CompanyTaxCodeConfig } from '../../../../models/tax-config';
import { AuditService } from '../../../../services/audit.service';
import { WorkersCompCode, WorkersCompLimit } from '../../../../workers-comp';
import { Enum, KeyPair, KeyTriple } from '../../../../models/base';
import { EmploymentTypes } from '../../../../models/employment-types';
import { toFloat } from '../../../../utils/math';
import {
  formatDatePickerValue,
  parseDatePickerValue
} from '../../../../utils/datepicker-value-parser';
import { getObjectDeltas } from '../../../../utils/object-deltas';
import { EmployeeStatus } from '../../../../models/person-status';
import { Person } from '../../../../models/person';
import { ToastService } from '../../../../services/toast.service';
import { Select, Store } from '@ngxs/store';
import {
  PersonEditorState,
  JobDetailsFormSelectors
} from '../../../../state/PersonEditorState/PersonEditor.state';
import { forkJoin, Observable, Subject } from 'rxjs';
import { ClientSelectionState } from '../../../../state/ClientSelectionState/ClientSelection.state';
import { EnumService } from '../../../../services/enum.service';
import { AdminService } from '../../../../services/admin.service';
import {
  AddEmployeeStatus,
  AddJobCode,
  AddLaborAllocation,
  EditEmployeeStatus,
  PersonStatusChanged,
  RefreshPerson,
  RemoveLaborAllocation,
  SetAllowDirectDeposit,
  SetCalendarId,
  SetCurrentTabDirty,
  SetCurrentTabStatus,
  SetLaborAllocations,
  SetOccupationChanged,
  SetPayFrequencyDetails,
  SetUseNewHireReporting,
  UpdateLaborAllocation
} from '../../../../state/PersonEditorState/PersonEditor.actions';
import { EmailDomainBlacklistValidator } from '../../../../utils/emailDomainBlacklistValidator';
import {
  SetBasisOfPayment,
  SetDepartment,
  SetDivision,
  SetEmployeeId,
  SetFullTimePartTime,
  SetHireDate,
  SetIncludeNonW2InWorkersComp,
  SetIsOwnerOfficer,
  SetIsSeasonal,
  SetJobDetailsFormState,
  SetJobTitle,
  SetLaborAllocationTotal,
  SetLocation,
  SetOccupationId,
  SetOKToAutoPay,
  SetOriginalHireDate,
  SetPayFrequency,
  SetShouldReportAsNewHire,
  SetSOCCode,
  SetWorkEmail,
  SetWorkersCompCode,
  SetWorkersCompLimitId,
  SetWorkersCompOwnerStatus,
  SetWorkPhoneNumber,
  SetWorksIn
} from '../../../../state/PersonEditorState/PersonEditor.JobDetailsForm.actions';

@Component({
  selector: 'app-job-details-tab',
  templateUrl: './job-details-tab.component.html',
  styleUrls: ['./job-details-tab.component.css'],
  standalone: false
})
export class JobDetailsTabComponent extends BaseComponent implements OnInit, OnDestroy {
  allocationHistory: EmployeeLaborAllocationHistory[] = [];
  basisOfPayments: Enum[] = [];
  @Select(ClientSelectionState.client) client: Observable<Client>;

  divisions: Division[] = [];
  @Select(PersonEditorState.getPotentialEmployeeStatuses)
  employeeStatuses: Observable<Enum[]>; // enum
  employeeStatusReasons: Enum[] = [];
  jobDeetsForm: FormGroup;
  occupations: Enum[] = [];
  organizationTypes = [];
  @Select(PersonEditorState.getEmploymentTypeId)
  employmentTypeId: Observable<number>;
  @Select(PersonEditorState.getReadOnly) readOnly: Observable<boolean>;
  @Select(PersonEditorState.getLocations) locations: Observable<CompanyLocationConfig[]>;
  @Select(PersonEditorState.getPerson) person: Observable<Person>;
  @Select(PersonEditorState.getLaborAllocations) laborAllocations: Observable<
    EmployeeLaborAllocation[]
  >;
  soccodes = [];
  @Select(PersonEditorState.getEmployeeStatuses) statuses: Observable<EmployeeStatus[]>;
  workersCompLimits: WorkersCompLimit[];

  @Output() laborAllocationsChanged: EventEmitter<any> = new EventEmitter();

  @ViewChildren(TableSorterDirective) headers: QueryList<TableSorterDirective>;

  activeLaborAllocation: number; // currently set value in the active modal
  allocationModalForm: UntypedFormGroup;
  availableCompCodes: WorkersCompCode[] = [];
  availableJobCodes: KeyPair[] = [];
  availableStates: KeyPair[] = [];
  availableStatuses = [];
  availableStateLimits: WorkersCompLimit[] = [];
  clientCode: string;
  currentLaborAllocations: number; // activeLaborAllocation + totalLaborAllocation
  departments: KeyTriple[] = [];
  disableParticipatingLimit: boolean; // task 10090
  employmentTypes = EmploymentTypes;
  isJobCodeValid = false;
  jobCodeAddMode = false;
  keyword = 'Value';
  laborAllocationTypes = LaborAllocationTypes;
  hireDate = null;
  maxDate = formatDatePickerValue(new Date());
  organizationType: string;
  calendars: PayrollCalendarSetup[] = [];
  selAllocationIdx = null;
  statusDescriptions = {};
  statusMinDate: any = {};
  statusModalForm: UntypedFormGroup;
  statusesCollapsed = true;
  today = new Date();
  totalLaborAllocation = 0; // sum of allocations saved not including activeLaborAllocations
  worksInState: string;
  workersCompRate: number;

  private destroy$ = new Subject<void>();

  private readonly toastService = inject(ToastService);

  constructor(
    private auditService: AuditService,
    public authService: AuthService,
    private companyService: CompaniesService,
    private formBuilder: UntypedFormBuilder,
    private modalService: ModalService,
    private ngModalService: NgbModal,
    private peopleService: PeopleService,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private store: Store,
    private enumService: EnumService,
    private adminService: AdminService,
    private emailBlacklistValidator: EmailDomainBlacklistValidator
  ) {
    super();
  }

  get f() {
    return this.jobDeetsForm.controls;
  }
  get a() {
    return this.allocationModalForm.controls;
  }
  get s() {
    return this.statusModalForm.controls;
  }

  addAllocation(content) {
    this.isJobCodeValid = false;
    this.jobCodeAddMode = false;
    this._setTotalLaborAllocation();
    this._setAvailableJobCodes();
    this.activeLaborAllocation = toFloat(100 - this.totalLaborAllocation);
    this.a.PercentageOfGrossPay.setValue(this.activeLaborAllocation);
    this.currentLaborAllocations = toFloat(this.activeLaborAllocation + this.totalLaborAllocation);

    this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
      this.ngModalService
        .open(content, {
          windowClass: 'centered',
          backdrop: 'static',
          keyboard: false
        })
        .result.then(
          result => {
            this.store.selectOnce(PersonEditorState.getJobCodes).subscribe(jobCodes => {
              // success
              if (this.allocationModalForm.valid) {
                // push saved data from form to model
                const jc = this.a.JobCodeId.value;
                // autocomplete library assigns KeyPair value to the form control
                if (typeof jc === 'object' && jc.Id && jc.Value) {
                  this.a.JobCodeId.setValue(jc.Id, { emitEvent: false });
                } else {
                  const code = jobCodes.find(x => x.Value == jc);
                  if (code) {
                    this.a.JobCodeId.setValue(code.Id, { emitEvent: false });
                  }
                }
                this.store
                  .dispatch(
                    new AddLaborAllocation(
                      new EmployeeLaborAllocation(
                        parseInt(this.a.JobCodeId.value, 10),
                        parseFloat(this.a.PercentageOfGrossPay.value)
                      )
                    )
                  )
                  .subscribe(() => {
                    this.store
                      .selectOnce(PersonEditorState.getLaborAllocations)
                      .subscribe(laborAllocations => {
                        if (person.Id) {
                          // for auditing purposes, fetch current labor allocations first
                          this.peopleService
                            .getLaborAllocations(this.clientCode, person.Id)
                            .subscribe(allocations => {
                              this.peopleService
                                .updateLaborAllocations(
                                  this.clientCode,
                                  person.Id,
                                  laborAllocations
                                )
                                .subscribe(
                                  response => {
                                    this.toastService.show('Save successful');

                                    this.sharedService.personEditsSaved.next();

                                    for (let i = 0; i < laborAllocations.length; i++) {
                                      const contextName = jobCodes.find(
                                        x => x.Id == laborAllocations[i].JobCodeId
                                      ).Value;
                                      const deltas = getObjectDeltas(
                                        allocations[i] || null,
                                        response.Model[i] || null,
                                        ['IntegrityHash'],
                                        contextName
                                      );
                                      if (Object.keys(deltas).length > 0) {
                                        this.auditService.auditEmployee(
                                          `employee-labor-allocation-updated`,
                                          {
                                            ClientCode: this.clientCode,
                                            PersonId: person.Id,
                                            EmployeeNumber: person.EmployeeId,
                                            EmployeeName: `${person.LastName}, ${person.FirstName}`
                                          },
                                          deltas
                                        );
                                      }
                                    }

                                    this.store.dispatch(new SetLaborAllocations(response.Model));
                                  },
                                  error => {
                                    this.store.dispatch(new SetLaborAllocations(allocations));
                                  }
                                );
                            });
                        }
                      });
                  });
              }

              this._setTotalLaborAllocation();
              this.allocationModalForm.reset();
            });
          },
          () => {
            // dismiss
            this.store.dispatch(new SetLaborAllocations([])).subscribe(() => {
              if (person.Id) {
                this.peopleService
                  .getLaborAllocations(this.clientCode, person.Id)
                  .subscribe(allocations => {
                    this.store.dispatch(new SetLaborAllocations(allocations));
                    this._setTotalLaborAllocation();
                  });
              } else {
                this._setTotalLaborAllocation();
              }

              this.allocationModalForm.reset();
            });
          }
        );
    });
  }

  addNewJobCode() {
    this.jobCodeAddMode = true;
  }

  addStatus(content) {
    this.store
      .selectOnce(PersonEditorState.getPotentialEmployeeStatuses)
      .subscribe(employeeStatuses => {
        this.getStatusesByDate().subscribe(statusesByDate => {
          const current = statusesByDate[0];
          this.availableStatuses = employeeStatuses.filter(
            x => x.Id != current.StatusId.toString()
          );

          // user cannot set new status date that comes before current status date
          this.statusMinDate = formatDatePickerValue(current.DateStatusChange);

          this.ngModalService
            .open(content, {
              windowClass: 'centered',
              backdrop: 'static',
              keyboard: false
            })
            .result.then(
              result => {
                this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
                  // success
                  if (this.statusModalForm.valid) {
                    const status = new EmployeeStatus(
                      parseInt(this.s.Status.value, 10),
                      parseDatePickerValue(this.s.DateStatusChange.value),
                      parseInt(this.s.Reason.value, 10)
                    );

                    this.store
                      .selectOnce(PersonEditorState.getEmployeeStatuses)
                      .subscribe(statuses => {
                        if (person.Id) {
                          this.peopleService
                            .addStatus(this.clientCode, person.Id, status)
                            .subscribe(response => {
                              this.store
                                .dispatch(new AddEmployeeStatus(response.Model))
                                .subscribe(() => {
                                  this.toastService.show('Save successful');

                                  this.sharedService.personEditsSaved.next();

                                  // bug 5627
                                  // refetch the person when status is changed to active to avoid integrity hash issues
                                  if (response.Model.StatusId === 0) {
                                    this.store.dispatch(new RefreshPerson(this.clientCode));
                                  }

                                  // record changes in the audit db
                                  const deltas = getObjectDeltas(
                                    null,
                                    response.Model,
                                    ['IntegrityHash', 'ReasonSequenceNumber'],
                                    this.statusDescriptions[status.StatusId]
                                  );
                                  this.auditService.auditEmployee(
                                    `employee-status-created`,
                                    {
                                      ClientCode: this.clientCode,
                                      PersonId: person.Id,
                                      EmployeeNumber: person.EmployeeId,
                                      EmployeeName: `${person.LastName}, ${person.FirstName}`
                                    },
                                    deltas
                                  );
                                });
                            });
                        } else {
                          this.store.dispatch(new AddEmployeeStatus(status));
                        }
                      });
                  }
                  this.statusModalForm.reset();
                });
              },
              () => {
                // dismiss
                this.statusModalForm.reset();
              }
            );
        });
      });
  }

  collapseStatuses() {
    this.statusesCollapsed = !this.statusesCollapsed;
  }

  continueAllocations() {
    this.store.selectOnce(PersonEditorState.getLaborAllocations).subscribe(laborAllocations => {
      this.store.selectOnce(PersonEditorState.getJobCodes).subscribe(jobCodes => {
        if (this.allocationModalForm.valid) {
          // push saved data from form to model
          const jc = this.a.JobCodeId.value;
          let val;
          // autocomplete library assigns KeyPair value to the form control
          if (typeof jc === 'object' && jc.Id && jc.Value) {
            val = jc.Id;
          } else {
            const code = jobCodes.find(x => x.Value == jc);
            if (code) {
              val = code.Id;
            }
          }
          val = parseInt(val, 10);

          if (laborAllocations[this.selAllocationIdx] != undefined) {
            laborAllocations[this.selAllocationIdx].JobCodeId = val;
            laborAllocations[this.selAllocationIdx].PercentageOfGrossPay = parseFloat(
              this.a.PercentageOfGrossPay.value
            );
          } else {
            this.store.dispatch(
              new AddLaborAllocation(
                new EmployeeLaborAllocation(val, parseFloat(this.a.PercentageOfGrossPay.value))
              )
            );
          }

          this.selAllocationIdx = null;
        }

        this._setTotalLaborAllocation();
        this.allocationModalForm.reset();

        // for some reason, even after resetting the form
        // the ng-automplete control keeps the value
        // referencing the element through ViewChild
        // unsuccessful due to reactive form setup
        const search = document
          .getElementsByTagName('ng-autocomplete')[0]
          .getElementsByTagName('input')[0];
        search.value = null;

        setTimeout(() => search.focus(), 100);
        this.isJobCodeValid = false;
        this.jobCodeAddMode = false;
        this._setAvailableJobCodes();
        this.activeLaborAllocation = toFloat(100 - this.totalLaborAllocation);
        this.a.PercentageOfGrossPay.setValue(this.activeLaborAllocation);
        this.currentLaborAllocations = toFloat(
          this.activeLaborAllocation + this.totalLaborAllocation
        );
      });
    });
  }

  deleteAllocation(allocation: EmployeeLaborAllocation) {
    this.store.selectOnce(PersonEditorState.getLaborAllocations).subscribe(laborAllocations => {
      this.store.selectOnce(PersonEditorState.getJobCodes).subscribe(jobCodes => {
        this.store.selectOnce(ClientSelectionState.client).subscribe(client => {
          const index = laborAllocations.indexOf(allocation);
          const allocType = this.laborAllocationTypes[client.LaborAllocationType];
          const description = jobCodes.find(x => x.Id == allocation.JobCodeId).Value;
          this.modalService.showConfirmModal(
            `Are you sure you want to delete ${allocType} ${description}?`,
            "Don't Delete",
            `Delete this ${allocType}`
          );
          this.modalService.confirmModalCallback.pipe(first()).subscribe((confirm: boolean) => {
            if (confirm) {
              this.store.dispatch(new RemoveLaborAllocation(allocation)).subscribe(() => {
                this.store
                  .selectOnce(PersonEditorState.getLaborAllocations)
                  .subscribe(newAllocations => {
                    this._setTotalLaborAllocation();

                    this.sharedService.personEditsSaved.next();

                    // fire API call only if user has deleted all the labor allocations
                    // front end logic prevents navigating away from tab
                    // when total labor allocations does not equal either 0 or 100
                    this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
                      if (person.Id && this.totalLaborAllocation === 0) {
                        // for auditing purposes, fetch current labor allocations first
                        this.peopleService
                          .getLaborAllocations(this.clientCode, person.Id)
                          .subscribe(allocations => {
                            this.peopleService
                              .updateLaborAllocations(this.clientCode, person.Id, newAllocations)
                              .subscribe(
                                () => {
                                  allocations.forEach(rule => {
                                    const contextName = jobCodes.find(
                                      x => x.Id == rule.JobCodeId
                                    ).Value;
                                    const deltas = getObjectDeltas(
                                      rule,
                                      null,
                                      ['IntegrityHash'],
                                      contextName
                                    );
                                    this.auditService.auditEmployee(
                                      `employee-labor-allocation-deleted`,
                                      {
                                        ClientCode: this.clientCode,
                                        PersonId: person.Id,
                                        EmployeeNumber: person.EmployeeId,
                                        EmployeeName: `${person.LastName}, ${person.FirstName}`
                                      },
                                      deltas
                                    );
                                  });
                                  this.store.dispatch(new SetLaborAllocations([])).subscribe(() => {
                                    this.toastService.show('Save successful');
                                    this._setTotalLaborAllocation();
                                  });
                                },
                                error => {
                                  this.store.dispatch(new SetLaborAllocations(allocations));
                                }
                              );
                          });
                      }
                    });
                  });
              });
            }
          });
        });
      });
    });
  }

  disableAllocationSave(): boolean {
    return (
      !this.allocationModalForm.valid ||
      this.jobCodeAddMode ||
      !this.isJobCodeValid ||
      !+this.activeLaborAllocation
    );
  }

  editAllocation(allocation: EmployeeLaborAllocation, content) {
    this.store.selectOnce(PersonEditorState.getLaborAllocations).subscribe(laborAllocations => {
      this.getJobCodeDescription(allocation.JobCodeId).subscribe(description => {
        this.selAllocationIdx = laborAllocations.indexOf(allocation);
        this.isJobCodeValid = true;
        this.jobCodeAddMode = false;

        this.allocationModalForm.patchValue(allocation);

        this.a.JobCodeId.setValue(description);
        this._setTotalLaborAllocation(allocation.JobCodeId);
        this._setAvailableJobCodes(allocation.JobCodeId);

        this.activeLaborAllocation = allocation.PercentageOfGrossPay;

        this.ngModalService
          .open(content, {
            windowClass: 'centered',
            backdrop: 'static',
            keyboard: false
          })
          .result.then(
            result => {
              this.store.selectOnce(PersonEditorState.getJobCodes).subscribe(jobCodes => {
                // // success
                if (this.allocationModalForm.valid) {
                  const jc = this.a.JobCodeId.value;
                  let id;
                  // autocomplete library assigns KeyPair value to the form control
                  if (typeof jc === 'object' && jc.Id && jc.Value) {
                    id = jc.Id;
                  } else {
                    const code = jobCodes.find(x => x.Value == jc);
                    if (code) {
                      id = code.Id;
                    } else {
                      id = parseInt(this.a.JobCodeId.value, 10);
                    }
                  }
                  let obs: Observable<any>;

                  if (laborAllocations[this.selAllocationIdx] != undefined) {
                    obs = this.store.dispatch(
                      new UpdateLaborAllocation(
                        laborAllocations[this.selAllocationIdx],
                        id,
                        parseFloat(this.a.PercentageOfGrossPay.value)
                      )
                    );
                  } else {
                    obs = this.store.dispatch(
                      new AddLaborAllocation(
                        new EmployeeLaborAllocation(
                          id,
                          parseFloat(this.a.PercentageOfGrossPay.value)
                        )
                      )
                    );
                  }
                  obs.subscribe(() => {
                    this.selAllocationIdx = null;
                    this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
                      this.store
                        .selectOnce(PersonEditorState.getLaborAllocations)
                        .subscribe(newAllocations => {
                          if (person.Id) {
                            // for auditing purposes, fetch current labor allocations first
                            this.peopleService
                              .getLaborAllocations(this.clientCode, person.Id)
                              .subscribe(allocations => {
                                this.peopleService
                                  .updateLaborAllocations(
                                    this.clientCode,
                                    person.Id,
                                    newAllocations
                                  )
                                  .subscribe(
                                    response => {
                                      this.store
                                        .selectOnce(PersonEditorState.getJobCodes)
                                        .subscribe(jobCodes => {
                                          this.toastService.show('Save successful');

                                          this.sharedService.personEditsSaved.next();

                                          for (let i = 0; i < newAllocations.length; i++) {
                                            const contextName = jobCodes.find(
                                              x => x.Id == newAllocations[i].JobCodeId
                                            ).Value;
                                            const deltas = getObjectDeltas(
                                              allocations[i] || null,
                                              response.Model[i] || null,
                                              ['IntegrityHash'],
                                              contextName
                                            );
                                            if (Object.keys(deltas).length > 0) {
                                              this.auditService.auditEmployee(
                                                `employee-labor-allocation-updated`,
                                                {
                                                  ClientCode: this.clientCode,
                                                  PersonId: person.Id,
                                                  EmployeeNumber: person.EmployeeId,
                                                  EmployeeName: `${person.LastName}, ${person.FirstName}`
                                                },
                                                deltas
                                              );
                                            }
                                          }
                                          this.store.dispatch(
                                            new SetLaborAllocations(response.Model)
                                          );
                                        });
                                    },
                                    error => {
                                      this.store.dispatch(new SetLaborAllocations(allocations));
                                    }
                                  );
                              });
                          }
                        });
                    });
                  });
                }

                this._setTotalLaborAllocation();
                this.allocationModalForm.reset();
              });
            },
            () => {
              // dismiss
              this.store.dispatch(new SetLaborAllocations([])).subscribe(() => {
                this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
                  if (person.Id) {
                    this.peopleService
                      .getLaborAllocations(this.clientCode, person.Id)
                      .subscribe(allocations => {
                        this.store.dispatch(new SetLaborAllocations(allocations));
                        this._setTotalLaborAllocation();
                      });
                  } else {
                    this._setTotalLaborAllocation();
                  }

                  this._setTotalLaborAllocation();
                  this.allocationModalForm.reset();
                });
              });
            }
          );
      });
    });
  }

  editStatus(statusObs: Observable<EmployeeStatus>, content) {
    statusObs.pipe(take(1)).subscribe(status => {
      this.store.selectOnce(PersonEditorState.getEmployeeStatuses).subscribe(statuses => {
        // user cannot edit the current status type. make the current status the only option
        this.availableStatuses = [
          { Id: status.StatusId, Value: this.statusDescriptions[status.StatusId] }
        ];

        this.s.Status.setValue(status.StatusId);
        this.s.DateStatusChange.setValue(formatDatePickerValue(status.DateStatusChange));
        this.s.Reason.setValue(status.ReasonSequenceNumber);

        this.getPastStatuses().subscribe(past => {
          // if there is a past status, make sure changing
          if (past && past.length > 0) {
            const last = past[0];
            this.statusMinDate = formatDatePickerValue(last.DateStatusChange);
          } else {
            this.statusMinDate = {};
          }

          this.ngModalService
            .open(content, {
              windowClass: 'centered',
              backdrop: 'static',
              keyboard: false
            })
            .result.then(
              result => {
                // success
                if (this.statusModalForm.valid) {
                  const s = structuredClone(status);
                  const editableStatus = structuredClone(status);
                  editableStatus.DateStatusChange = parseDatePickerValue(
                    this.s.DateStatusChange.value
                  );
                  editableStatus.ReasonSequenceNumber = parseInt(this.s.Reason.value, 10);

                  this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
                    if (person.Id) {
                      this.peopleService
                        .updateStatus(
                          this.clientCode,
                          person.Id,
                          editableStatus.SequenceNumber,
                          editableStatus
                        )
                        .subscribe(response => {
                          this.toastService.show('Save successful');
                          this.store
                            .dispatch(new EditEmployeeStatus(response.Model))
                            .subscribe(() => {
                              this.sharedService.personEditsSaved.next();

                              // record changes in the audit db
                              const deltas = getObjectDeltas(
                                s,
                                response.Model,
                                ['IntegrityHash', 'ReasonSequenceNumber'],
                                this.statusDescriptions[status.StatusId]
                              );
                              if (Object.keys(deltas).length > 0) {
                                this.auditService.auditEmployee(
                                  `employee-status-updated`,
                                  {
                                    ClientCode: this.clientCode,
                                    PersonId: person.Id,
                                    EmployeeNumber: person.EmployeeId,
                                    EmployeeName: `${person.LastName}, ${person.FirstName}`
                                  },
                                  deltas
                                );
                              }
                            });
                        });
                    } else {
                      this.store.dispatch(new EditEmployeeStatus(status));
                    }
                  });
                }
                this.statusModalForm.reset();
              },
              () => {
                // dismiss
                this.statusModalForm.reset();
              }
            );
        });
      });
    });
  }

  getJobCodeDescription(codeId, descripOnly: boolean = false): Observable<string> {
    return this.store.selectOnce(PersonEditorState.getJobCodes).pipe(
      map(jobCodes => {
        const d = jobCodes.find(x => x.Id == codeId);
        if (d && !descripOnly) {
          return d.Value;
        } else if (d && descripOnly) {
          // values comes from server as {{ code - description }}
          return d.Value.split('-').length > 0
            ? d.Value.split('-')[d.Value.split('-').length - 1].trim()
            : d.Value;
        } else {
          return '';
        }
      })
    );
  }

  getOGHireDateErrorMsg(ogHireDate, hireDate) {
    let error = 'invalid date';

    if (ogHireDate && hireDate) {
      const ogHire = parseDatePickerValue(ogHireDate);
      const hire = parseDatePickerValue(hireDate);

      if (ogHire > hire) {
        const formatted = moment(hire).format('MM/DD/YYYY');
        error = `Original hire date must be before or the same as hire date ${formatted}`;
      }
    }

    return error;
  }

  getPastStatuses(): Observable<EmployeeStatus[]> {
    return this.getStatusesByDate().pipe(
      map(statuses => {
        const past = [...statuses];
        past.splice(0, 1);
        return past;
      })
    );
  }

  getReasonValue(id) {
    const val = this.employeeStatusReasons.find(x => x.Id == id);
    return val ? val.Value : '';
  }

  getStatusesByDate(): Observable<EmployeeStatus[]> {
    return this.store.selectOnce(PersonEditorState.getEmployeeStatuses).pipe(
      map(employeeStatuses => {
        const statuses = [...employeeStatuses].sort((a: EmployeeStatus, b: EmployeeStatus) => {
          return new Date(b.DateStatusChange).getTime() - new Date(a.DateStatusChange).getTime();
        });

        return statuses;
      })
    );
  }

  getCurrentStatus(): Observable<EmployeeStatus> {
    return this.getStatusesByDate().pipe(map(statuses => statuses[0]));
  }

  getFirstLocation(): Observable<CompanyLocationConfig> {
    return this.store
      .selectOnce(PersonEditorState.getLocations)
      .pipe(map(locations => locations[0]));
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.store.selectOnce(ClientSelectionState.clientCode).subscribe(clientCode => {
      this.clientCode = clientCode;
      this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
        const obs: any[] = [
          this.enumService.get('EmpBasisOfPayment'),
          this.companyService.getDivisions(clientCode),
          this.enumService.get('EmployeeStatusReason'),
          this.enumService.get('OCCUPATIONS'),
          this.enumService.get('SOC'),
          this.adminService.getWorkersCompLimits(),
          this.enumService.get('OrganizationTypes')
        ];
        if (person.Id) {
          obs.push(this.peopleService.getLaborAllocationHistory(this.clientCode, person.Id));
        }
        forkJoin(obs).subscribe((result: any) => {
          this.basisOfPayments = result[0];
          this.divisions = result[1];
          this.employeeStatusReasons = result[2];
          this.occupations = result[3];
          this.soccodes = result[4];
          this.workersCompLimits = result[5];
          this.organizationTypes = result[6];
          if (person.Id) {
            this.allocationHistory = result[7];
          } else {
            this.allocationHistory = [];
          }
          this.init();
        });
      });
    });
  }

  init() {
    this.store
      .selectOnce(JobDetailsFormSelectors.jobDetailsFormModel)
      .subscribe(jobDetailsFormModel => {
        this.store
          .selectOnce(PersonEditorState.getPotentialEmployeeStatuses)
          .subscribe(employeeStatuses => {
            employeeStatuses.forEach(status => {
              this.statusDescriptions[status.Id] = status.Value;
            });
          });

        this.jobDeetsForm = this.formBuilder.group({
          EmployeeId: new FormControl(jobDetailsFormModel.EmployeeId, [
            Validators.maxLength(4),
            Validators.pattern('[0-9]*$')
          ]),
          HireDate: new FormControl(jobDetailsFormModel.HireDate),
          ShouldReportAsNewHire: new FormControl(jobDetailsFormModel.ShouldReportAsNewHire),
          WorksIn: new FormControl(jobDetailsFormModel.WorksIn, Validators.required),
          OKToAutoPay: new FormControl(jobDetailsFormModel.OKToAutoPay),
          PayFrequency: new FormControl(jobDetailsFormModel.PayFrequency),
          Location: new FormControl(jobDetailsFormModel.Location),
          Division: new FormControl(jobDetailsFormModel.Division),
          Department: new FormControl(jobDetailsFormModel.Department),
          JobTitle: new FormControl(jobDetailsFormModel.JobTitle),
          IsSeasonal: new FormControl(jobDetailsFormModel.IsSeasonal),
          FullTimePartTime: new FormControl(jobDetailsFormModel.FullTimePartTime),
          IsOwnerOfficer: new FormControl(jobDetailsFormModel.IsOwnerOfficer),
          SOCCode: new FormControl(jobDetailsFormModel.SOCCode),
          OccupationId: new FormControl(jobDetailsFormModel.OccupationId),
          BasisOfPayment: new FormControl(jobDetailsFormModel.BasisOfPayment),
          WorkEmailAddress: new FormControl(
            jobDetailsFormModel.WorkEmailAddress,
            [Validators.email],
            [this.emailBlacklistValidator.validate.bind(this.emailBlacklistValidator)]
          ),
          WorkPhoneNumber: new FormControl(jobDetailsFormModel.WorkPhoneNumber),
          OriginalHireDate: new FormControl(jobDetailsFormModel.OriginalHireDate),
          IncludeNonW2InWorkersComp: new FormControl(jobDetailsFormModel.IncludeNonW2InWorkersComp),
          WorkersCompCode: new FormControl(jobDetailsFormModel.WorkersCompCode),
          WorkersCompOwnerStatus: new FormControl(jobDetailsFormModel.WorkersCompOwnerStatus),
          WorkersCompLimitId: new FormControl(jobDetailsFormModel.WorkersCompLimitId),
          // used only to mark valid/dirty based on labor allocation total
          // in order to prevent user from changing tabs when total != 100
          LaborAllocationTotal: new FormControl(jobDetailsFormModel.LaborAllocationTotal)
        });

        this.jobDeetsForm.statusChanges
          .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
          .subscribe(status => {
            this.store.dispatch(new SetJobDetailsFormState(status));
            if (status != null) {
              this.store.dispatch(new SetCurrentTabStatus(status));
            }
          });
        this.jobDeetsForm.valueChanges
          .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
          .subscribe(() => {
            if (this.jobDeetsForm.dirty) {
              this.store.dispatch(new SetCurrentTabDirty(this.jobDeetsForm.dirty));
            }
          });

        this.store
          .select(PersonEditorState.markFormTouched)
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => {
            const controls = this.jobDeetsForm.controls;
            Object.keys(controls).forEach(key => {
              controls[key].markAsTouched();
            });
          });
        this.store
          .select(PersonEditorState.triggerMarkFormPristine)
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => {
            this.jobDeetsForm.markAsPristine();
            this.jobDeetsForm.markAsUntouched();
            this.store.dispatch(new SetCurrentTabDirty(false));
          });
        this.allocationModalForm = this.formBuilder.group({
          JobCodeId: new FormControl('', [Validators.required]),
          Description: new FormControl(''),
          PercentageOfGrossPay: new FormControl('', [Validators.required, Validators.max(100)])
        });

        this.statusModalForm = this.formBuilder.group({
          Status: new FormControl('', [Validators.required]),
          DateStatusChange: new FormControl('', [Validators.required]),
          Reason: new FormControl()
        });

        // user story 4601
        const eIdCtrl = this.jobDeetsForm.controls.EmployeeId;
        this.store.selectOnce(ClientSelectionState.client).subscribe(client => {
          if (client.AutogenerateEmployeeId) {
            eIdCtrl.disable();
            eIdCtrl.clearValidators();

            if (!eIdCtrl.value && eIdCtrl.value !== 0) {
              eIdCtrl.setValue('0');
            }
          } else {
            eIdCtrl.setValidators([
              Validators.maxLength(4),
              Validators.pattern('[0-9]*$'),
              Validators.required
            ]);
          }
          eIdCtrl.updateValueAndValidity();
        });

        this._updateOgHireDateValidation(this.f.HireDate.value);
        this._setHireDateHooks();

        this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
          if (!this.f.HireDate.value && !person.Id) {
            this.f.HireDate.setValue(formatDatePickerValue(new Date()));
          }
        });

        this._updateLocations();

        // update the Pay Frequency options when the user changes the Location
        this.f.Location.valueChanges.subscribe(val => {
          if (val || val === 0) {
            this.f.PayFrequency.setValue('');
            this._updatePayFrequencies(parseInt(val, 10));

            // emit change to parent in order to enable/disable the direct deposit tab
            // based on location.AllowDirectDeposits
            this.store.selectOnce(PersonEditorState.getLocations).subscribe(locations => {
              this.store.dispatch(new SetAllowDirectDeposit(locations[0].AllowDirectDeposit));
            });
          }
        });
        this._updateDivisions();

        this.s.Status.valueChanges.subscribe(val => {
          this.store
            .selectOnce(PersonEditorState.getPotentialEmployeeStatuses)
            .subscribe(employeeStatuses => {
              const status = employeeStatuses.find(x => x.Id === val);
              if (status && status.Value.toLowerCase() === 'leave of absence') {
                this.s.Reason.setValidators([Validators.required]);
              } else {
                this.s.Reason.clearValidators();
              }

              this.s.Reason.updateValueAndValidity();
            });
        });

        // user story 4605
        if (
          this.f.ShouldReportAsNewHire.value === null ||
          this.f.ShouldReportAsNewHire.value === undefined
        ) {
          this.store
            .selectOnce(PersonEditorState.getUseNewHireReporting)
            .subscribe(useNewHireReporting => {
              if (!useNewHireReporting) {
                this.f.ShouldReportAsNewHire.setValue('0');
              } else {
                this.f.ShouldReportAsNewHire.setValue('1');
              }
            });
        }

        setTimeout(() => {
          // set default selection until user leaves people edit screen
          // and toggle original hire date requirement
          this.f.ShouldReportAsNewHire.valueChanges.subscribe(val => this._updateHireDate(val));
        }, 0);

        this._updateHireDate(this.f.ShouldReportAsNewHire.value);

        this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
          this.store
            .selectOnce(PersonEditorState.getEmploymentTypeId)
            .subscribe(employmentTypeId => {
              // Bug 5257 - if creating new employee and type is k1 or w2, default
              // wc option to "not an owner/officer"
              if (
                !person.Id &&
                (employmentTypeId == EmploymentTypes.K1 || employmentTypeId == EmploymentTypes.W2)
              ) {
                this.jobDeetsForm.controls.WorkersCompOwnerStatus.setValue('1', {
                  emitEvent: false
                });
              }
            });
        });

        this.f.WorkersCompOwnerStatus.valueChanges.subscribe(() => {
          if (this.f.WorkersCompOwnerStatus.value != '4') {
            this.f.WorkersCompLimitId.setValue(0);
          }
        });

        this._setAvailableStates();

        // workers comp
        this._setWorkersCompHook();
        this._setCompCodeRatesHook();
        this._setOrgType();
        this._setOwnerOfficerHook();

        this._setTotalLaborAllocation();

        this.store.selectOnce(PersonEditorState.getReadOnly).subscribe(readOnly => {
          // bug 8022, when client is locked, all person editor fields are disabled
          if (readOnly) {
            this.disableAllFormControls(this.allocationModalForm);
            this.disableAllFormControls(this.statusModalForm);
          }
        });
        this.store.selectOnce(PersonEditorState.getJobCodes).subscribe(jobCodes => {
          sessionStorage.setItem('job-code-list', JSON.stringify(jobCodes));
        });

        this.connectFormToStateStore();
        this.jobDeetsForm.markAsUntouched();
        this.jobDeetsForm.markAsPristine();
      });
  }

  onDivisionChange() {
    this._updateDepartments(this.f.Division.value);
  }

  // job code autocomplete control
  onJobCodeChange($event) {
    this.store.selectOnce(PersonEditorState.getJobCodes).subscribe(jobCodes => {
      this.isJobCodeValid = !!(
        typeof this.a.JobCodeId.value === 'object' ||
        jobCodes.find(x => x.Id == this.a.JobCodeId.value) ||
        jobCodes.find(x => x.Value == this.a.JobCodeId.value)
      );
    });
  }

  onJobCodeFocused() {
    this.a.JobCodeId.markAsTouched();
  }

  onJobCodeSelect() {
    this.isJobCodeValid = true;
  }

  onOccupationChange() {
    this.store.dispatch(new SetOccupationChanged(true));
  }

  onPayFrequencyChange() {
    const val = this.f.PayFrequency.value;
    const cal = this.calendars.find(x => x.Frequency === parseInt(val, 10));
    this.store.dispatch(
      new SetPayFrequencyDetails(cal ? cal.Frequency : null, cal ? cal.CalendarId : null)
    );
  }

  onSort({ column, direction }: SortEvent | any) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // sorting countries
    if (direction !== '') {
      this.allocationHistory = [...this.allocationHistory].sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  saveNewJobCode() {
    if (this.a.JobCodeId.value && this.a.Description.value) {
      const jobCode = new JobCode(this.a.JobCodeId.value, this.a.Description.value);
      this.companyService.createJobCode(this.clientCode, jobCode).subscribe(x => {
        const obj = {
          Id: x.Model.Id,
          Value: `${x.Model.Code}  -  ${x.Model.Description}`
        };
        this.availableJobCodes.push(obj);
        this.store.dispatch(new AddJobCode(obj)).subscribe(() => {
          this.store.selectOnce(PersonEditorState.getJobCodes).subscribe(jobCodes => {
            sessionStorage.setItem('job-code-list', JSON.stringify(jobCodes));

            this.a.JobCodeId.setValue(x.Model.Id, {
              emitEvent: false
            });
            this.isJobCodeValid = true;
            this.jobCodeAddMode = false;

            this.sharedService.personEditsSaved.next();
          });
        });
      });
    }
  }

  public selValueRender(value) {
    // render function inside ng-autocomplete
    // "this" changes context to the autocomplete control
    // so access to the component gets tricky
    const codes = sessionStorage.getItem('job-code-list');

    // for clients that alloc by job code,
    // display 'None' in selector by default
    // if no allocations have been set
    if (value == 'None') {
      return value;
    }

    if (!codes) {
      return value;
    }

    const list = JSON.parse(codes);
    return value ? list.find(x => x.Id == +value)?.Value || value : null;
  }

  setCurrentLaborAllocations(e) {
    const val =
      e && e.target && e.target.value ? e.target.value : this.a.PercentageOfGrossPay.value;
    this.activeLaborAllocation = +val;
    this.currentLaborAllocations = toFloat(+val + this.totalLaborAllocation);
  }

  viewAllocationHistory(content) {
    this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
      if (person.Id && this.allocationHistory && this.allocationHistory.length > 0) {
        // map description to remove the "job code id - " prefix. for table sorting purposes
        this.allocationHistory.map(x => {
          this.getJobCodeDescription(x.JobCodeId, true).subscribe(description => {
            x.Description = description;
          });
        });
        this.ngModalService
          .open(content, {
            size: 'xl' as 'lg',
            backdrop: 'static',
            keyboard: false
          })
          .result.then(
            () => {},
            () => {}
          );
      }
    });
  }

  // #region PRIVATE METHODS

  private _setAvailableStates() {
    this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
      // Bug 4990 - filter to determine which tax configs we use to populate the Works In dropdown
      const stateFilter = taxConfig => {
        // exclude any non-unemployment tax configs
        if (taxConfig.TaxType != 'U') {
          return false;
        }

        // if the config is active, it passes.  if it's inactive, only include it if the employee
        // is set as "Works In" that state (so we display works-in properly)
        if (taxConfig.IsActive) {
          return true;
        } else {
          return this.person && person.WorksIn == taxConfig.StateAbbreviation;
        }
      };

      this.store.selectOnce(PersonEditorState.getCompanyTaxConfigs).subscribe(taxConfigs => {
        this.store.selectOnce(PersonEditorState.getStates).subscribe(statesEnum => {
          const stateConfigs = taxConfigs.filter(stateFilter);
          const states = [];
          if (stateConfigs && stateConfigs.length > 0) {
            stateConfigs.forEach(c => {
              const state = statesEnum.find(s => s.Id === c.StateAbbreviation);
              if (state !== undefined && state !== null) {
                states.push({ Id: state.Id, Value: state.Value });
              }
            });
          }

          this.availableStates = states;
        });
      });
    });
  }

  private _setAvailableJobCodes(includeId = null) {
    this.store.selectOnce(PersonEditorState.getLaborAllocations).subscribe(laborAllocations => {
      this.store.selectOnce(PersonEditorState.getJobCodes).subscribe(jobCodes => {
        // bug 5355. only allow a job code/dept to be selected once
        this.availableJobCodes = [];
        jobCodes.forEach(x => {
          const rule = laborAllocations.find(a => a.JobCodeId == x.Id);
          if (!rule || (rule && includeId == x.Id)) {
            this.availableJobCodes.push(x);
          }
        });
      });
    });
  }

  // Bug 5256 - apparently workers comp codes can be repeated across states????
  // seeing '2000' as the code for both Ohio and Illinois WC codes under company JDWCCR  --nk 2019-10-23
  private _setCompCodeRate(state: string = null, compCode: string = null) {
    this.store.selectOnce(PersonEditorState.getWorkersCompCodes).subscribe(workersCompCodes => {
      let code = workersCompCodes.find(x => x.StateCode == state && x.Code === compCode);
      this.workersCompRate = code ? code.Rate : null;
    });
  }

  private _setCompCodeRatesHook() {
    this._setCompCodeRate(this.f.WorksIn.value, this.f.WorkersCompCode.value);
    this.f.WorkersCompCode.valueChanges.subscribe(val =>
      this._setCompCodeRate(this.f.WorksIn.value, val)
    );
  }

  private _setOrgType() {
    this.store.selectOnce(ClientSelectionState.client).subscribe(client => {
      if (client.OrganizationTypeId) {
        const orgType = this.organizationTypes.find(x => x.Id == client.OrganizationTypeId);
        this.organizationType = orgType ? orgType.Value : '';
      } else {
        this.organizationType = '';
      }
    });
  }

  private _setOwnerOfficerHook() {
    this.f.IsOwnerOfficer.valueChanges.subscribe(val => this._setOwnerOfficerValidation(val));
  }

  // story 4681. can't check 'owner/officer' in job details tile
  // and select 'not owner/officer' in workers comp tile
  private _setOwnerOfficerValidation(val) {
    const wcOwnerStatus = this.f.WorkersCompOwnerStatus.value;
    if (val && (!wcOwnerStatus || wcOwnerStatus == '1')) {
      this.f.WorkersCompOwnerStatus.setValue('2');
    } else if (!val) {
      this.f.WorkersCompOwnerStatus.setValue('1');
    }
  }

  private _setTotalLaborAllocation(code = null) {
    this.store.selectOnce(PersonEditorState.getLaborAllocations).subscribe(laborAllocations => {
      this.totalLaborAllocation = 0;
      laborAllocations.forEach(x => {
        if (!code || code != x.JobCodeId) {
          this.totalLaborAllocation += x.PercentageOfGrossPay;
          // eliminate floating point error
          this.totalLaborAllocation = toFloat(this.totalLaborAllocation);
        }
      });

      const max = toFloat(100.0 - this.totalLaborAllocation);
      this.allocationModalForm
        .get('PercentageOfGrossPay')
        .setValidators([Validators.required, Validators.max(max)]);

      // marks form as invalid if total != 0 or 100.
      // prevents user from changing tabs in this state
      if (this.totalLaborAllocation === 0 || this.totalLaborAllocation === 100) {
        this.f.LaborAllocationTotal.clearValidators();
      } else {
        this.f.LaborAllocationTotal.setValidators(Validators.required);
      }

      this.f.LaborAllocationTotal.updateValueAndValidity();

      this.currentLaborAllocations = toFloat(
        +this.a.PercentageOfGrossPay.value + this.totalLaborAllocation
      );
    });
  }

  private _setWorkersCompHook() {
    this.store.selectOnce(ClientSelectionState.client).subscribe(client => {
      this.store.selectOnce(PersonEditorState.getEmploymentTypeId).subscribe(employmentTypeId => {
        if (
          client.RequiresWorkersCompCodes &&
          this.availableCompCodes.length > 0 &&
          employmentTypeId == EmploymentTypes.W2
        ) {
          // make WC code required if client is setup and (person is w2 or if 'include in WC' checkbox is checked)
          this.f.WorkersCompCode.setValidators([Validators.required]);
        } else {
          this.f.WorkersCompCode.clearValidators();
        }

        this.f.WorkersCompCode.updateValueAndValidity();

        // when 'include' checkbox is checked - toggle WC code requirement
        this.f.IncludeNonW2InWorkersComp.valueChanges.subscribe(val => {
          if (val && this.availableCompCodes.length > 0) {
            this.f.WorkersCompCode.setValidators([Validators.required]);
          } else {
            this.f.WorkersCompCode.clearValidators();
          }

          this.f.WorkersCompCode.updateValueAndValidity();
        });

        this._updateWorkersComp(this.f.WorksIn.value, true);
        this.f.WorksIn.valueChanges.subscribe(val => this._updateWorkersComp(val));
      });
    });
  }

  private _setHireDateHooks() {
    this.f.HireDate.valueChanges.subscribe(val => {
      this._updateOgHireDateValidation(val);
    });
  }

  private _updateOgHireDateValidation(val) {
    // make sure hire date is valid before setting original hire date max date
    if (val && this.f.HireDate.valid) {
      const date = new Date(val.year, val.month, val.day);
      this.hireDate = {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate()
      };
    } else {
      this.hireDate = null;
    }
  }

  private _updateDepartments(selectedDivisionId: number, preventDefault: boolean = true) {
    const ctrl = this.jobDeetsForm.controls.Department;
    const div = _.find(this.divisions, itm => itm.Id == selectedDivisionId);
    if (div) {
      this.departments = _.sortBy(div.Departments, 'Id');
    } else {
      this.departments = [];
    }

    //Do not disable control if there are no departments, validation still needs to run
    ctrl.enable();

    this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
      if (this.departments.length === 1 && !ctrl.value && ctrl.value !== 0) {
        // BUG 5359 - do not default logic if we have a dept value of 0 (No Departments)
        // issue occurs when departments are added to a client after a person was created
        // once this tab loads, our default logic set values behind the scenes
        // but form is still clean and save btn is disabled
        if (!preventDefault || !person.Id) {
          ctrl.setValue(this.departments[0].Id);
          this.store.dispatch(new SetDepartment(this.departments[0].Id.toString()));
        }
      }
      if (ctrl.value === 0) {
        // In all cases require validation
        // clear the value set so the required validation fires
        ctrl.setValue('');
        this.store.dispatch(new SetDepartment(''));
      }

      if (this.departments.length > 0 && selectedDivisionId !== person.Division) {
        this.store.dispatch(new SetDepartment(this.departments[0].Id.toString()));
      }
      ctrl.setValidators([Validators.required]);

      ctrl.updateValueAndValidity();

      this.store.selectOnce(PersonEditorState.getReadOnly).subscribe(readOnly => {
        // bug 8022, when client is locked, all person editor fields are disabled
        if (readOnly) {
          ctrl.disable();
        }
      });
    });
  }

  private _updateDivisions() {
    this.divisions = _.sortBy(this.divisions, 'Name');
    const ctrl = this.f.Division;

    if (this.divisions.length < 2) {
      ctrl.disable();
    } else {
      ctrl.enable();
    }

    this.store.selectOnce(PersonEditorState.getPerson).subscribe(person => {
      // set default division if no division is assigned and we have
      // EXACTLY 1 division to pick from.
      // NOTE: this logic was initially committed for bug 4974
      // to master in 0f41f660 and lost in a merge
      if (this.divisions && this.divisions.length === 1 && !ctrl.value && ctrl.value !== 0) {
        ctrl.setValue(this.divisions[0].Id, { emitEvent: false });
        this.store.dispatch(new SetDivision(this.divisions[0].Id.toString()));
      } else if (
        (this.divisions.length > 1 ||
          (this.divisions.length === 1 && this.divisions[0].Id !== 0)) &&
        person.Id &&
        ctrl.value === 0
      ) {
        // bug 5359 - if person has no division set (person.Division = 0)
        // but now there are divisions available on the client
        // (ignoring the 'No Division' item with Id 0 of course...)
        // do not default value and force user to select a division
        // clear as mud, right?
        ctrl.enable();
        ctrl.setValue('');
      }

      if (this.divisions.length > 0) {
        ctrl.setValidators([Validators.required]);
      } else {
        ctrl.clearValidators();
      }

      ctrl.updateValueAndValidity();

      this._updateDepartments(ctrl.value, true);

      this.store.selectOnce(PersonEditorState.getReadOnly).subscribe(readOnly => {
        // bug 8022, when client is locked, all person editor fields are disabled
        if (readOnly) {
          ctrl.disable();
        }
      });
    });
  }

  private _updateLocations() {
    this.store.selectOnce(PersonEditorState.getLocations).subscribe(locations => {
      let sortedLocations = _.sortBy(locations, 'Name');
      const ctrl = this.jobDeetsForm.controls.Location;

      if (sortedLocations.length < 2) {
        ctrl.disable({ emitEvent: false });
      } else {
        ctrl.enable({ emitEvent: false });
      }

      // we'll always have at least one location record from the API;
      // default to the first value
      if (sortedLocations && sortedLocations.length > 0 && !ctrl.value && ctrl.value !== 0) {
        ctrl.setValue(sortedLocations[0].Id, { emitEvent: false });
        this.store.dispatch(new SetLocation(sortedLocations[0].Id.toString()));
      }

      this._updatePayFrequencies(
        ctrl.value || ctrl.value == 0 ? ctrl.value : sortedLocations[0].Id
      );
      this.store.dispatch(new SetAllowDirectDeposit(sortedLocations[0].AllowDirectDeposit));

      // bug 8022, when client is locked, all person editor fields are disabled
      this.store.selectOnce(PersonEditorState.getReadOnly).subscribe(readOnly => {
        if (readOnly) {
          ctrl.disable({ emitEvent: false });
        }
      });
    });
  }

  private _updateHireDate(newHire: string) {
    if (newHire == '1') {
      this.store.dispatch(new SetUseNewHireReporting(true));
      this.f.HireDate.setValidators([Validators.required]);
    } else if (newHire == '0') {
      this.store.dispatch(new SetUseNewHireReporting(false));
      this.f.HireDate.clearValidators();
    }

    this.f.HireDate.updateValueAndValidity();
  }

  // update pay frequency options when Location changes
  private _updatePayFrequencies(selectedLocationId: number) {
    this.store.selectOnce(PersonEditorState.getLocations).subscribe(locations => {
      // update our pay frequency options from the selected location
      const loc = _.find(locations, itm => itm.Id === selectedLocationId);
      this.calendars = loc.Calendars;
      const ctrl = this.jobDeetsForm.controls.PayFrequency;

      // if there are no frequencies to choose from, or only one, disable the control.
      // if there's only one option, it will automatically be selected, since we
      // automatically set the selection to the first value in the list
      if (this.calendars.length < 2) {
        ctrl.disable();
      } else {
        ctrl.enable();
      }

      if (this.calendars && this.calendars.length > 0 && !ctrl.value && ctrl.value !== 0) {
        ctrl.setValue(this.calendars[0].Frequency, { emitEvent: false });
        this.store.dispatch(new SetPayFrequency(this.calendars[0].Frequency));
        this.onPayFrequencyChange(); // set CalendarId
      } else if (!this.calendars || this.calendars.length === 0) {
        this.store.dispatch(new SetCalendarId(0));
      }

      this.store.selectOnce(PersonEditorState.getReadOnly).subscribe(readOnly => {
        // bug 8022, when client is locked, all person editor fields are disabled
        if (readOnly) {
          ctrl.disable();
        }
      });
    });
  }

  private _updateWorkersComp(stateCode: string = null, tabInit: boolean = false) {
    this.store.selectOnce(PersonEditorState.getEmploymentTypeId).subscribe(employmentTypeId => {
      // update workers comp
      if (stateCode) {
        this.store.selectOnce(PersonEditorState.getWorkersCompCodes).subscribe(workersCompCodes => {
          this.store.selectOnce(PersonEditorState.getStates).subscribe(statesEnum => {
            const state = statesEnum.find(x => x.Id == stateCode);
            this.worksInState = state.Value;

            this.availableCompCodes = workersCompCodes.filter(x => x.StateCode === stateCode);
            this.availableStateLimits = this.workersCompLimits.filter(
              x => x.StateCode === stateCode
            );

            // bug 10360 - do not preselect the workers comp code on page load.
            // this causes issues when an invalid to pay employee page is loaded
            // after the required WC codes have been added to the client. the form
            // preselects the value, but does not allow the user to save, making it
            // appear this value is set on the person when it is not.
            if (tabInit) {
              // carry on
            } else if (this.availableCompCodes.length >= 1) {
              // Bug 5256: comp codes are not unique - they can actually repeat for different states,
              // eg IL and OH both have a '2000' code.  update the code manually without triggering
              // our usual event handler, and set the rate manually
              this.f.WorkersCompCode.setValue(this.availableCompCodes[0].Code, {
                emitEvent: false
              });
              this._setCompCodeRate(stateCode, this.availableCompCodes[0].Code);
            }
            // no comp codes available
            else if (!this.f.WorkersCompCode.value && this.availableCompCodes.length == 0) {
              this.f.WorkersCompCode.setValue(null);
            }

            if (
              this.availableStateLimits.length > 0 &&
              this.availableCompCodes.length > 0 &&
              (!this.f.WorkersCompLimitId.value || !tabInit)
            ) {
              this.f.WorkersCompLimitId.setValue(this.availableStateLimits[0].Id.toString());
            }
          });
        });
      } else {
        this.worksInState = '';
        this.availableCompCodes = [];
        this.availableStateLimits = [];
      }

      this.store.selectOnce(ClientSelectionState.client).subscribe(client => {
        // refire workers comp validation
        if (
          client.RequiresWorkersCompCodes &&
          this.availableCompCodes.length > 0 &&
          employmentTypeId == EmploymentTypes.W2
        ) {
          // make WC code required if client is setup and (person is w2 or if 'include in WC' checkbox is checked)
          this.f.WorkersCompCode.setValidators([Validators.required]);
        } else {
          this.f.WorkersCompCode.clearValidators();
        }

        this.f.WorkersCompCode.updateValueAndValidity();

        // task 10090
        // disable if the chosen works in state has no participating limits
        this.disableParticipatingLimit = this.availableStateLimits.length == 0;

        // if Participating owner/officer with limit is selected
        // but the state is changed to one that has no limits,
        // change radio selection to 'Non-participating owner/officer'
        if (!this.availableStateLimits.length && this.f.WorkersCompOwnerStatus.value == '4') {
          this.jobDeetsForm.controls.WorkersCompOwnerStatus.setValue('2', {
            emitEvent: false
          });
        }
      });
    });
  }

  private connectFormToStateStore() {
    this.jobDeetsForm
      .get('EmployeeId')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetEmployeeId(val));
      });
    this.store
      .select(JobDetailsFormSelectors.employeeId)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('EmployeeId');
        if (control.value != val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('HireDate')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetHireDate(val));
      });
    this.store
      .select(JobDetailsFormSelectors.hireDate)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('HireDate');
        if (control.value != val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('ShouldReportAsNewHire')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetShouldReportAsNewHire(val));
      });
    this.store
      .select(JobDetailsFormSelectors.shouldReportAsNewHire)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('ShouldReportAsNewHire');
        if (control.value != val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('WorksIn')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetWorksIn(val));
      });
    this.store
      .select(JobDetailsFormSelectors.worksIn)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('WorksIn');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('OKToAutoPay')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetOKToAutoPay(val));
      });
    this.store
      .select(JobDetailsFormSelectors.okToAutoPay)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('OKToAutoPay');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('PayFrequency')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetPayFrequency(val));
      });
    this.store
      .select(JobDetailsFormSelectors.payFrequency)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('PayFrequency');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('Location')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetLocation(val));
      });
    this.store
      .select(JobDetailsFormSelectors.location)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('Location');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('Division')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetDivision(val));
      });
    this.store
      .select(JobDetailsFormSelectors.division)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('Division');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('Department')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetDepartment(val));
      });
    this.store
      .select(JobDetailsFormSelectors.department)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('Department');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('JobTitle')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetJobTitle(val));
      });
    this.store
      .select(JobDetailsFormSelectors.jobTitle)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('JobTitle');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('IsSeasonal')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetIsSeasonal(val));
      });
    this.store
      .select(JobDetailsFormSelectors.isSeasonal)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('IsSeasonal');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('FullTimePartTime')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetFullTimePartTime(val));
      });
    this.store
      .select(JobDetailsFormSelectors.fullTimePartTime)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('FullTimePartTime');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('IsOwnerOfficer')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetIsOwnerOfficer(val));
      });
    this.store
      .select(JobDetailsFormSelectors.isOwnerOfficer)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('IsOwnerOfficer');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('SOCCode')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetSOCCode(val));
      });
    this.store
      .select(JobDetailsFormSelectors.socCode)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('SOCCode');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('OccupationId')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetOccupationId(val));
      });
    this.store
      .select(JobDetailsFormSelectors.occupationId)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('OccupationId');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('BasisOfPayment')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetBasisOfPayment(val));
      });
    this.store
      .select(JobDetailsFormSelectors.basisOfPayment)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('BasisOfPayment');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('WorkEmailAddress')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetWorkEmail(val));
      });
    this.store
      .select(JobDetailsFormSelectors.workEmail)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('WorkEmailAddress');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('WorkPhoneNumber')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetWorkPhoneNumber(val));
      });
    this.store
      .select(JobDetailsFormSelectors.workPhoneNumber)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('WorkPhoneNumber');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('OriginalHireDate')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetOriginalHireDate(val));
      });
    this.store
      .select(JobDetailsFormSelectors.originalHireDate)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('OriginalHireDate');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('IncludeNonW2InWorkersComp')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetIncludeNonW2InWorkersComp(val));
      });
    this.store
      .select(JobDetailsFormSelectors.includeNonW2InWorkersComp)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('IncludeNonW2InWorkersComp');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('WorkersCompCode')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetWorkersCompCode(val));
      });
    this.store
      .select(JobDetailsFormSelectors.workersCompCode)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('WorkersCompCode');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('WorkersCompOwnerStatus')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetWorkersCompOwnerStatus(val));
      });
    this.store
      .select(JobDetailsFormSelectors.workersCompOwnerStatus)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('WorkersCompOwnerStatus');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('WorkersCompLimitId')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetWorkersCompLimitId(val));
      });
    this.store
      .select(JobDetailsFormSelectors.workersCompLimitId)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('WorkersCompLimitId');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.jobDeetsForm
      .get('LaborAllocationTotal')
      .valueChanges.pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.store.dispatch(new SetLaborAllocationTotal(val));
      });
    this.store
      .select(JobDetailsFormSelectors.laborAllocationTotal)
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        const control = this.jobDeetsForm.get('LaborAllocationTotal');
        if (control.value !== val) {
          control.setValue(val, { emitEvent: false });
        }
      });

    this.store.dispatch(new SetCurrentTabDirty(false));
    this.store.dispatch(new SetCurrentTabStatus(this.jobDeetsForm.status));
  }

  // #endregion
}
